"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogParser = void 0;
var abi_1 = require("@ethersproject/abi");
var LogParser = /** @class */ (function () {
    function LogParser(abiItems) {
        this.abiInterface = new abi_1.Interface(abiItems);
    }
    LogParser.prototype.read = function (log) {
        // Solidity supports max 3 topics. https://docs.soliditylang.org/en/latest/contracts.html#events
        var topics = [log.topic0, log.topic1, log.topic2, log.topic3].filter(function (t) { return t !== null; });
        // Do not call the `this.abiInterface.parseLog()` method here! The @ethersproject/abi package (5.7.0) has a bug,
        // that doesn't return `args` with named keys in a specific case. That problem doesn't occur when we call directly the decodeEventLog() method.
        var eventFragment = this.abiInterface.getEvent(topics[0]);
        var args = this.abiInterface.decodeEventLog(eventFragment, log.data, topics);
        var params = {};
        for (var _i = 0, _a = eventFragment.inputs; _i < _a.length; _i++) {
            var input = _a[_i];
            var value = args[input.name];
            if (value instanceof abi_1.Indexed) {
                value = value.hash;
            }
            params[input.name] = {
                type: input.type,
                value: value,
            };
        }
        return {
            name: eventFragment.name,
            params: params,
        };
    };
    return LogParser;
}());
exports.LogParser = LogParser;
//# sourceMappingURL=LogParser.js.map